import RecommenderResponse from '../../components/Recommenders/RecommenderResponse';

const RecommendersTab = ({ recommendations }) => {
  const recommendationResponses = [];
  for (let i = 0; i < recommendations.length; i++) {
    recommendationResponses.push(<RecommenderResponse key={i} recommendation={recommendations[i]} />);
  }

  return recommendationResponses;
};

export default RecommendersTab;
